import {NgModule, ModuleWithProviders, OpaqueToken, Optional, SkipSelf, Inject} from '@angular/core';

import {HttpModule} from '@angular/http';
import {CommonModule} from '@angular/common';

import {DropzoneComponent} from './dropzone.component';
import {DropzoneDirective} from './dropzone.directive';
import {DropzoneConfig, DropzoneConfigInterface} from './dropzone.interfaces';

export const DROPZONE_GUARD = new OpaqueToken('DROPZONE_GUARD');
export const DROPZONE_CONFIG = new OpaqueToken('DROPZONE_CONFIG');


export class DropzoneModule {
    constructor(  guard: any) {
    }

    static forRoot(config?: DropzoneConfigInterface): ModuleWithProviders {
        return {
            ngModule: DropzoneModule,
            providers: [
                {
                    provide: DROPZONE_GUARD,
                    useFactory: provideForRootGuard,
                    deps: [
                        [
                            DropzoneConfig,
                            new Optional(),
                            new SkipSelf()
                        ]
                    ]
                },
                {
                    provide: DROPZONE_CONFIG,
                    useValue: config ? config : {}
                },
                {
                    provide: DropzoneConfig,
                    useFactory: provideDefaultConfig,
                    deps: [
                        DROPZONE_CONFIG
                    ]
                }
            ]
        };
    }

    static forChild(): ModuleWithProviders {
        return {
            ngModule: DropzoneModule
        };
    }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, HttpModule],
    declarations: [DropzoneComponent, DropzoneDirective],
    exports: [CommonModule, HttpModule, DropzoneComponent, DropzoneDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DROPZONE_GUARD, ] }, ]},
];
}

export function provideForRootGuard(config: DropzoneConfig): any {
    if (config) {
        throw new Error(`
      Application called DropzoneModule.forRoot() twice.
      For submodules use DropzoneModule.forChild() instead.
    `);
    }

    return 'guarded';
}

export function provideDefaultConfig(config: DropzoneConfigInterface): DropzoneConfig {
    return new DropzoneConfig(config);
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
